import PropTypes from 'prop-types';
import { BsPencil, BsTrash3, BsPlusCircle, BsDownload } from "react-icons/bs";
import { HiOutlineArrowSmallUp, HiOutlineArrowSmallDown, HiOutlineCog6Tooth } from "react-icons/hi2";
import { MdError } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { RxCopy } from "react-icons/rx";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-icon.clickable:hover {\n  cursor: pointer;\n}\n.kof-icon[disabled] {\n  opacity: 0.5;\n}";
  const fileName = "Icon_Icon_c5885db2-8bee-40a5-a40d-4fa340b8abba";
  const element = document.querySelector("style[data-sass-component='Icon_Icon_c5885db2-8bee-40a5-a40d-4fa340b8abba']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const createBaseIconProps = (onClick, disabled, size, className) => {
  return {
    className: ['kof-icon', onClick && !disabled ? 'clickable' : null, className].filter(item => item).join(' '),
    onClick: !disabled ? onClick : null,
    size: size,
    disabled
  };
};
function Icon({
  type,
  onClick,
  className,
  size = 16,
  disabled = false
}) {
  const elementProps = createBaseIconProps(onClick, disabled, size, className);
  switch (type) {
    case 'add':
      return /*#__PURE__*/_jsx(BsPlusCircle, {
        ...elementProps
      });
    case 'change':
      return /*#__PURE__*/_jsx(BsPencil, {
        ...elementProps
      });
    case 'up':
      return /*#__PURE__*/_jsx(HiOutlineArrowSmallUp, {
        ...elementProps
      });
    case 'down':
      return /*#__PURE__*/_jsx(HiOutlineArrowSmallDown, {
        ...elementProps
      });
    case 'remove-trash':
      return /*#__PURE__*/_jsx(BsTrash3, {
        ...elementProps
      });
    case 'remove-x':
    case 'close':
      return /*#__PURE__*/_jsx(AiOutlineClose, {
        ...elementProps
      });
    case 'download':
      return /*#__PURE__*/_jsx(BsDownload, {
        ...elementProps
      });
    case 'copy':
      return /*#__PURE__*/_jsx(RxCopy, {
        ...elementProps
      });
    case 'settings':
      return /*#__PURE__*/_jsx(HiOutlineCog6Tooth, {
        ...elementProps
      });
    case 'next':
      return /*#__PURE__*/_jsx(IoChevronForward, {
        ...elementProps
      });
    case 'previous':
      return /*#__PURE__*/_jsx(IoChevronBack, {
        ...elementProps
      });
    case 'error':
      elementProps.className = `${elementProps.className} error`;
      return /*#__PURE__*/_jsx(MdError, {
        ...elementProps
      });
    case 'success':
      elementProps.className = `${elementProps.className} success`;
      return /*#__PURE__*/_jsx(FaCheck, {
        ...elementProps
      });
  }
}
Icon.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.number,
  disabled: PropTypes.bool
};
export { Icon, createBaseIconProps };